module.exports = __webpack_public_path__ + "static/media/008-sun-1.14dbec19.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/CareIcons/008-sun-1.png
// module id = 642
// module chunks = 0